export type FeatureKey = 'credit' | 'loyalty' | 'aiCoaching' | 'lactateTest' | 'workoutBuilder'

type FeatureVisibilityOptions = {
  isCreditFeatureEnabled: boolean
  isLoyaltyFeatureEnabled: boolean
  isAiCoachingEnabled: boolean
  isLactateTestEnabled: boolean
  isWorkoutBuilderEnabled: boolean
}

export const isFeatureEnabled = (
  feature: FeatureKey | undefined,
  options: FeatureVisibilityOptions
): boolean => {
  if (!feature) return true

  if (feature === 'credit') {
    return options.isCreditFeatureEnabled
  }

  if (feature === 'loyalty') {
    return options.isLoyaltyFeatureEnabled
  }

  if (feature === 'aiCoaching') {
    return options.isAiCoachingEnabled
  }

  if (feature === 'lactateTest') {
    return options.isLactateTestEnabled
  }

  if (feature === 'workoutBuilder') {
    return options.isWorkoutBuilderEnabled
  }

  return true
}
